import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

const API = process.env.REACT_APP_API_BASE_URL;
const WISE_ACCOUNT_URL = `${API}/account/user/wise-account`;

export const WISE_TAG_PATTERN = /^[A-Za-z0-9._-]{3,64}$/;
export const WISE_ACCOUNT_QUERY_KEY = ['wiseAccount'];

export const normalizeWiseTag = (value) => {
  if (typeof value !== 'string') {
    throw new Error('Invalid Wisetag');
  }

  const trimmed = value.trim();
  const normalized = trimmed.startsWith('@') ? trimmed.slice(1) : trimmed;

  if (!WISE_TAG_PATTERN.test(normalized)) {
    throw new Error('Invalid Wisetag');
  }

  return normalized;
};

const getResponseData = (response) => {
  if (typeof response?.status === 'number' && (response.status < 200 || response.status >= 300)) {
    const error = new Error('Wise account request failed');
    error.response = response;
    throw error;
  }

  return response?.data;
};

export const getWiseAccount = async ({ signal } = {}) => {
  const response = await axios.get(WISE_ACCOUNT_URL, { signal });
  return getResponseData(response);
};

export const useWiseAccount = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: WISE_ACCOUNT_QUERY_KEY,
    queryFn: ({ signal }) => getWiseAccount({ signal }),
    enabled,
    retry: false
  });

export const updateWiseAccount = async (wiseTag) => {
  const normalizedWiseTag = normalizeWiseTag(wiseTag);
  const response = await axios.put(WISE_ACCOUNT_URL, { wiseTag: normalizedWiseTag });
  return getResponseData(response);
};
